import { io } from 'socket.io-client';

// La URL debe ser la de tu Backend
const SOCKET_URL = process.env.REACT_APP_API_URL || 'http://localhost:2000';

export const socket = io(SOCKET_URL, {
  autoConnect: true,
  transports: ['websocket'] // Forzamos websocket para evitar problemas de CORS/Polling
});